/**
 * Valida um campo de formulário qualquer e exibe a mensagem de erro quando o campo estiver inválido
 * @param {HTMLInputElement} input      Elemento a ser validado
 * @return {void}
 */
function validateInputField(input)
{
    let spanMsg = $(input).siblings(".msg-error-field");
    if ($(input).closest('.check-container').length) {
        spanMsg = $(input).closest('.check-container').siblings(".msg-error-field");
        if (spanMsg.length === 0) {
            return;
        }
        // Verifica se ao menos um checkbox/radio do grupo está selecionado
        let groupName = $(input).attr("name");
        updateStateCheckboxRequired(groupName);
    }

    $(input)[0].setCustomValidity("");
    $(input).removeClass("invalid-field");
    spanMsg.removeClass("show-error");

    if (!$(input)[0].checkValidity()) {
        $(input)[0].setCustomValidity(spanMsg.text());
        $(input).addClass("invalid-field");
        spanMsg.addClass("show-error");
    }
}

function updateStateCheckboxRequired(groupName)
{
    let isAnyChecked = $(`input[name="${groupName}"]:checked`).length > 0;
    if (isAnyChecked) {
        $(`input[name="${groupName}"]`).each(function() {
            $(this).prop("required", false);
        });
        return;
    }

    $(`input[name="${groupName}"]`).each(function() {
        $(this).prop("required", true);
    });
}
